import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';
import { breadcrumbJsonLd } from '../seo/structuredData';
import voices from '../content/voices';
import { useI18n } from '../i18n/I18nContext';
import './Stimmen.css';

function Stimmen() {
  const { lang, copy } = useI18n();
  const items = lang === 'en' ? copy.testimonials.voices : voices;

  return (
    <div className="michaela-stimmen-page">
      <Seo
        page="stimmen"
        jsonLd={breadcrumbJsonLd([
          { name: 'Home', path: lang === 'en' ? '/en' : '/' },
          { name: copy.testimonials.crumb, path: lang === 'en' ? '/en/testimonials' : '/stimmen' },
        ])}
      />
      <Header />

      <section className="michaela-stimmen-hero">
        <div className="michaela-stimmen-hero-content">
          <h1 className="michaela-stimmen-title">{copy.testimonials.title}</h1>
          {copy.testimonials.note ? (
            <p className="michaela-stimmen-note">{copy.testimonials.note}</p>
          ) : null}
        </div>
      </section>

      <section className="michaela-stimmen-main" aria-label={copy.testimonials.aria}>
        <div className="michaela-stimmen-list">
          {items.map((voice, index) => (
            <blockquote key={voice.id || index} className="michaela-stimmen-card">
              <p className="michaela-stimmen-quote">„{voice.quote}“</p>
              <footer className="michaela-stimmen-attr">{voice.attribution}</footer>
            </blockquote>
          ))}
        </div>
      </section>

      <Footer showContactForm={false} />
    </div>
  );
}

export default Stimmen;
